import React from 'react';
import { JuridicalReferencesProvider } from '../contexts/JuridicalReferencesContext';
import { ImageCacheProvider } from '../contexts/ImageCacheContext';
import { SpatialProvider } from '../contexts/SpatialContext';
import { SidebarProvider } from '../contexts/SidebarContext';
import DossierResourceGate from './DossierResourceGate';
import { useDossier } from './DossierContext';
import DossierEditor from './DossierEditor';

/**
 * Point d'entrée de la route `/dossiers/:id`.
 *
 * Hiérarchie :
 *   - DossierResourceGate         : charge la ressource + dispatch UI
 *   - DossierProvider (interne)   : monté par le Gate, expose le ctx
 *   - Providers contextuels       : Spatial, Sidebar, JuridicalRefs,
 *                                   ImageCache — internes à l'éditeur,
 *                                   non partagés avec MyFolders
 *   - DossierEditor               : layout + autosave + raccourcis
 */
const DossierEditorRoute: React.FC = () => (
  <DossierResourceGate>
    <SpatialProvider>
      <SidebarProvider>
        <ImageCacheProvider>
          <DossierEditorJuridicalRefsBridge>
            <DossierEditor />
          </DossierEditorJuridicalRefsBridge>
        </ImageCacheProvider>
      </SidebarProvider>
    </SpatialProvider>
  </DossierResourceGate>
);

/**
 * Le `JuridicalReferencesProvider` actuel exige un `initialDossier`
 * pour amorcer son extraction des références HTML. On l'alimente
 * depuis le `DossierContext` plutôt que de drill une prop.
 */
const DossierEditorJuridicalRefsBridge: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { dossier } = useDossier();
  return (
    <JuridicalReferencesProvider initialDossier={dossier}>{children}</JuridicalReferencesProvider>
  );
};

export default DossierEditorRoute;
